export const GREETING_MESSAGE_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/greetingMessageSchemaV1_0_0.json' as const;
export const GREETING_MESSAGE_COMPONENT_TYPE = 'GreetingMessage' as const;
